/**
 * Script/style loader helpers — verbatim ports of everything_else.js
 * loadScript/loadCSS/loadScripts and process_product_page.js loadStyle.
 *
 * loadScripts(): Font Awesome 6.6.0 CSS+JS from cdnjs, NO dedup — one pair per
 * render (research/01 §5.6; research/02 §12.7).
 * loadStyle(): promise resolves on load AND on error (console.warn), and
 * short-circuits with the "<id> already exists" log when the id is present.
 */
export function loadScript(url: string): void {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  document.getElementsByTagName("head")[0]!.appendChild(script);
}

export function loadCSS(url: string): void {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = url;
  document.getElementsByTagName("head")[0]!.appendChild(link);
}

export function loadScripts(): void {
  //CSS
  // loadCSS("https://code.jquery.com/ui/1.13.3/themes/base/jquery-ui.css");
  loadCSS(
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css",
  );

  //JS
  // loadScript("https://code.jquery.com/ui/1.13.3/jquery-ui.min.js");
  loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/js/all.min.js",
  );
}

export async function loadStyle(href: string, id: string): Promise<void> {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      console.log(`${id} already exists`);
      return resolve();
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;
    link.onload = () => {
      console.log(`${id} loaded successfully`);
      resolve();
    };
    link.onerror = () => {
      console.warn(`Failed to load stylesheet: ${href}`);
      resolve();
    };
    document.head.appendChild(link);
  });
}
